/**
 * Sticky Header
 * Adds a class to header on scroll
 */
import magnificPopup from '../vendors/jquery-magnificpopup';
import organicTabs from '../vendors/organic-tab';
import slick from '../vendors/slick.min';
jQuery( document ).on( 'scroll', function() {
	if ( jQuery( document ).scrollTop() > 0 ) {
		jQuery( 'header, body' ).addClass( 'shrink' );
	} else {
		jQuery( 'header, body' ).removeClass( 'shrink' );
	}
} );

jQuery( function() {
	/**
	 * Header Wrapper Height Calculation for Navigation Overlay
	 */

	if ( jQuery( '.header-wrapper' ).length > 0 ) {
		function updateHeaderHeight() {
			jQuery( '.header-wrapper' ).each( function() {
				jQuery( this ).css( '--ns_header-wrapper-default', jQuery( this ).outerHeight() + 'px' );
			} );
		}
		updateHeaderHeight();
		jQuery( window ).resize( updateHeaderHeight );
	}

	/**
	 * Toggle menu for mobile
	 */
	const navOverlay = jQuery( '.nav-overlay' );
	const htmlBody = jQuery( 'html, body' );
	const menuBtn = jQuery( '.menu-btn' );

	jQuery( '.menu-btn' ).on( 'click', function() {
		jQuery( this ).toggleClass( 'active' );
		navOverlay.toggleClass( 'open' );
		htmlBody.toggleClass( 'no-overflow' );
		jQuery( '.header-nav ul li.active' ).removeClass( 'active' );
		jQuery( '.header-nav ul.sub-menu' ).slideUp();
	} );

	jQuery( document ).on( 'click', function( e ) {
		const $headerNav = jQuery( '.header-nav' );

		if (
		  navOverlay.hasClass( 'open' ) &&
		  ! $headerNav.is( e.target ) &&
		  $headerNav.has( e.target ).length === 0 &&
		  ! jQuery( e.target ).closest( '.menu-btn' ).length // ignore menu button clicks
		) {
		  menuBtn.removeClass( 'active' );
		  navOverlay.removeClass( 'open' );
		  htmlBody.removeClass( 'no-overflow' );
		  jQuery( '.header-nav ul li.active' ).removeClass( 'active' );
		  jQuery( '.header-nav ul.sub-menu' ).slideUp();
		}
	  } );

	/**
	 * Add span tag to multi-level accordion menu for mobile menus
	 */

	jQuery( '.menu-item-has-children > a:first-child' ).each( function() {
		jQuery( this ).after( '<span class="submenu-icon"></span>' );
	} );

	/**
	 * Slide Up/Down internal sub-menu when mobile menu arrow clicked
	 */

	jQuery( '.header-nav' ).on( 'click', '.submenu-icon', function() {
		const parentLi = jQuery( this ).closest( 'li' );

		parentLi.siblings( '.active' )
			.removeClass( 'active' )
			.find( 'ul' ).slideUp();

		parentLi.toggleClass( 'active' ).find( 'ul' ).stop( true, true ).slideToggle();
		// parentLi.parents( 'ul' ).toggleClass( 'disabled-menu', parentLi.hasClass( 'active' ) );
	} );

	/**
	 *  Accessibility for Simple menu & Mega menu
	 */
	jQuery( '.menu-item-has-children > a' ).on( 'focus blur', function( event ) {
		jQuery( this ).siblings( '.sub-menu, .mega-menu' ).toggleClass( 'focused', event.type === 'focus' );
	} );

	jQuery( '.sub-menu a, .mega-menu a' ).on( 'focus blur', function( event ) {
		jQuery( this ).closest( '.sub-menu, .mega-menu' ).toggleClass( 'focused', event.type === 'focus' );
	} );

	/**
	 * Script for Accessibility of html Tags
	 */
	jQuery( 'h1, h2, h3, h4, h5, h6,p,li,blockquote,cite,strong,dt,dd,th,td,b,i,u,s,em,small,sup,del,ins,abbr,mark,details,pre,kbd,samp,var,address,code,q,figure,figcaption,caption,.top-bar-text,.top-bar-cross,.copy-right,.post-author-img,.post-author-name,.post-meta-date,.post-date' ).each( function() {
		jQuery( this ).attr( {
			tabindex: 0,
		} );
	} );
	jQuery( '.header-nav li, .blog-nav li, .footer-nav li, .legal-nav li' ).each( function() {
		const link = jQuery( this ).find( 'a' );
		if ( link.length > 0 ) {
			jQuery( this ).removeAttr( 'tabindex' );
		} else {
			jQuery( this ).attr( 'tabindex', '0' );
		}
	} );
	jQuery( 'form p' ).each( function() {
		jQuery( this ).removeAttr( 'tabindex' );
	} );

	jQuery( 'a,button:not([href])' ).each( function() {
		jQuery( this ).attr( {
			tabindex: 0,
		} );
	} );

	setTimeout( () => {
		jQuery( '#daextlwcnf-cookie-notice-button-1' ).attr( 'role', 'button' );
		jQuery( '#daextlwcnf-cookie-notice-button-2' ).attr( 'role', 'button' );
		jQuery( '#daextlwcnf-cookie-settings-button-1' ).attr( 'role', 'button' );
		jQuery( '#daextlwcnf-cookie-settings-button-2' ).attr( 'role', 'button' );
	}, 500 );

	autosize();
	function autosize() {
		const text = jQuery( 'textarea' );

		text.each( function() {
			jQuery( this ).attr( 'rows', 5 );
			resize( jQuery( this ) );
		} );

		text.on( 'input', function() {
			resize( jQuery( this ) );
		} );

		function resize( $text ) {
			$text.css( 'min-height', 'auto' );
			$text.css( 'min-height', $text[ 0 ].scrollHeight + 'px' );
		}
	}

	let currentPlayingSection = null;

	/**
	 * Single Video Block Handler - Play/Pause functionality (File Upload)
	 */

	jQuery( '.video-section.video-block' ).each( function() {
		const section = jQuery( this );
		const videoArea = section.find( '.video-area' );
		const videoElement = videoArea.find( 'video' ).get( 0 );
		const playIcon = videoArea.find( '.play-icon' );
		const playButton = playIcon.find( '.play-icon-btn' );

		if ( ! videoElement || playButton.length === 0 ) {
			return;
		}

		// Start paused and ensure button shows pause state
		videoElement.pause();
		videoElement.currentTime = 0;
		videoElement.muted = false;
		playButton.addClass( 'video-pause' );

		// Play button click handler
		playButton.on( 'click', function( e ) {
			e.stopPropagation();
			e.preventDefault();

			if ( videoElement.paused ) {
				videoElement.play();
				playButton.removeClass( 'video-pause' );
			} else {
				videoElement.pause();
				playButton.addClass( 'video-pause' );
			}
		} );

		// Click on video area to play/pause
		videoArea.on( 'click', function( e ) {
			// Don't trigger if clicking on the button itself
			if ( jQuery( e.target ).closest( '.play-icon' ).length ) {
				return;
			}

			if ( videoElement.paused ) {
				videoElement.play();
				playButton.removeClass( 'video-pause' );
			} else {
				videoElement.pause();
				playButton.addClass( 'video-pause' );
			}
		} );
	} );

	jQuery( '.video-section' ).each( function() {
		const section = jQuery( this );
		const posterVideo = section.find( '.poster-video video' ).get( 0 );
		const fullVideoWrapper = section.find( '.full-video' );
		const fullVideo = fullVideoWrapper.find( 'video' ).get( 0 );
		const playButton = section.find( '.play-icon-btn' );
		const muteButton = section.find( '.audio-icon' );
		const fullscreenButton = section.find( '.full-screen' );
		const progressFill = section.find( '.video-progress-fill' );

		if ( ! fullVideo ) {
			return;
		}

		fullVideoWrapper.hide();
		fullVideo.pause();
		fullVideo.currentTime = 0;

		if ( posterVideo ) {
			posterVideo.muted = true;
			posterVideo.play();
		}

		section.find( '.poster-video' ).on( 'click', function() {
			if ( currentPlayingSection && currentPlayingSection.get( 0 ) !== section.get( 0 ) ) {
				const prevPoster = currentPlayingSection.find( '.poster-video' );
				const prevPosterVideo = prevPoster.find( 'video' ).get( 0 );
				const prevWrapper = currentPlayingSection.find( '.full-video' );
				const prevVideo = prevWrapper.find( 'video' ).get( 0 );
				const prevPlayButton = currentPlayingSection.find( '.play-icon-btn' );

				if ( prevVideo ) {
					prevVideo.pause();
					prevVideo.currentTime = 0;
					prevWrapper.hide();
					prevPoster.show();
					if ( prevPosterVideo ) {
						prevPosterVideo.currentTime = 0;
						prevPosterVideo.play();
					}
					prevPlayButton.removeClass( 'video-pause' );
				}
			}

			if ( posterVideo ) {
				posterVideo.pause();
			}

			section.find( '.poster-video' ).fadeOut( 100, function() {
				fullVideoWrapper.fadeIn( 100 );
				fullVideo.currentTime = 0;
				fullVideo.play();
				playButton.removeClass( 'video-pause' );
				currentPlayingSection = section;
			} );
		} );

		fullVideoWrapper.on( 'click', function() {
			if ( fullVideo.paused ) {
				fullVideo.play();
				playButton.removeClass( 'video-pause' );
			} else {
				fullVideo.pause();
				playButton.addClass( 'video-pause' );
			}
		} );

		playButton.on( 'click', function( e ) {
			e.stopPropagation();
			if ( fullVideo.paused ) {
				fullVideo.play();
				playButton.removeClass( 'video-pause' );
			} else {
				fullVideo.pause();
				playButton.addClass( 'video-pause' );
			}
		} );

		muteButton.on( 'click', function() {
			fullVideo.muted = ! fullVideo.muted;
			muteButton.toggleClass( 'video-muted', fullVideo.muted );
		} );

		fullscreenButton.on( 'click', function() {
			if ( document.fullscreenElement ) {
				document.exitFullscreen();
				fullscreenButton.removeClass( 'video-fullscreen' );
			} else {
				fullVideoWrapper.get( 0 ).requestFullscreen();
				fullscreenButton.addClass( 'video-fullscreen' );
			}
		} );

		fullVideo.addEventListener( 'timeupdate', function() {
			const percentage = ( this.currentTime / this.duration ) * 100;
			progressFill.css( 'width', percentage + '%' );
		} );
	} );

	/**
	 * Vimeo Play/Pause and Audio Control Handler
	 */
	jQuery( '.hero-project-image' ).each( function() {
		const heroImage = jQuery( this );
		const vimeoIframe = heroImage.find( 'iframe.ns-vimeo-iframe' );

		if ( vimeoIframe.length === 0 ) {
			return;
		}

		const playIcon = heroImage.find( '.play-icon' );
		const playBtn = playIcon.find( '.play-icon-btn' );
		const audioBtn = playIcon.find( '.audio-icon' );

		const iframeEl = vimeoIframe.get( 0 );
		const vimeoOrigin = 'https://player.vimeo.com';

		let isReady = false;
		let isPlaying = false;
		let isMuted = true;

		function syncButtonClasses() {
			playBtn.toggleClass( 'video-pause', ! isPlaying );
			audioBtn.toggleClass( 'video-muted', isMuted );
		}

		function sendToVimeo( method, value ) {
			if ( ! iframeEl || ! iframeEl.contentWindow ) {
				return;
			}

			const payload = { method };
			if ( typeof value !== 'undefined' ) {
				payload.value = value;
			}

			iframeEl.contentWindow.postMessage( JSON.stringify( payload ), vimeoOrigin );
		}

		function bindVimeoEvents() {
			sendToVimeo( 'addEventListener', 'play' );
			sendToVimeo( 'addEventListener', 'pause' );
			sendToVimeo( 'addEventListener', 'volumechange' );
		}

		function setInitialVimeoState() {
			sendToVimeo( 'pause' );
			sendToVimeo( 'setCurrentTime', 0 );
			sendToVimeo( 'setVolume', 0 );
		}

		function handleVimeoMessage( event ) {
			if ( event.origin !== vimeoOrigin ) {
				return;
			}

			if ( event.source !== iframeEl.contentWindow ) {
				return;
			}

			if ( ! event.data ) {
				return;
			}

			let data;
			try {
				data = typeof event.data === 'string' ? JSON.parse( event.data ) : event.data;
			} catch ( e ) {
				return;
			}

			if ( ! data || typeof data !== 'object' ) {
				return;
			}

			if ( data.event === 'ready' ) {
				isReady = true;
				bindVimeoEvents();
				setInitialVimeoState();
				syncButtonClasses();
				return;
			}

			if ( data.event === 'play' ) {
				isPlaying = true;
				syncButtonClasses();
				return;
			}

			if ( data.event === 'pause' ) {
				isPlaying = false;
				syncButtonClasses();
				return;
			}

			if ( data.event === 'volumechange' && data.data && typeof data.data.volume !== 'undefined' ) {
				isMuted = Number( data.data.volume ) === 0;
				syncButtonClasses();
			}
		}

		syncButtonClasses();

		window.addEventListener( 'message', handleVimeoMessage, false );
		sendToVimeo( 'addEventListener', 'ready' );

		playBtn.off( 'click.nsVimeo' ).on( 'click.nsVimeo', function( e ) {
			e.preventDefault();
			e.stopPropagation();

			if ( isPlaying ) {
				sendToVimeo( 'pause' );
				return;
			}

			// Unmute and play video
			sendToVimeo( 'setVolume', 1 );
			sendToVimeo( 'play' );
		} );

		audioBtn.off( 'click.nsVimeo' ).on( 'click.nsVimeo', function( e ) {
			e.preventDefault();
			e.stopPropagation();

			if ( isMuted ) {
				sendToVimeo( 'setVolume', 1 );
				return;
			}

			sendToVimeo( 'setVolume', 0 );
		} );

		if ( ! isReady ) {
			setTimeout( () => {
				sendToVimeo( 'addEventListener', 'ready' );
			}, 250 );
		}
	} );

	/**
	 * Theme Video Block Vimeo Play/Pause Handler (Single Variation)
	 */
	jQuery( '.video-section.video-block .video-area' ).each( function() {
		const videoArea = jQuery( this );
		const vimeoIframe = videoArea.find( 'iframe.ns-vimeo-iframe' );

		if ( vimeoIframe.length === 0 ) {
			return;
		}

		const playIcon = videoArea.find( '.play-icon' );
		const playBtn = playIcon.find( '.play-icon-btn' );

		const iframeEl = vimeoIframe.get( 0 );
		const vimeoOrigin = 'https://player.vimeo.com';

		let isReady = false;
		let isPlaying = false;

		function syncButtonClasses() {
			playBtn.toggleClass( 'video-pause', ! isPlaying );
		}

		function sendToVimeo( method, value ) {
			if ( ! iframeEl || ! iframeEl.contentWindow ) {
				return;
			}

			const payload = { method };
			if ( typeof value !== 'undefined' ) {
				payload.value = value;
			}

			iframeEl.contentWindow.postMessage( JSON.stringify( payload ), vimeoOrigin );
		}

		function bindVimeoEvents() {
			sendToVimeo( 'addEventListener', 'play' );
			sendToVimeo( 'addEventListener', 'pause' );
		}

		function setInitialVimeoState() {
			sendToVimeo( 'pause' );
			sendToVimeo( 'setCurrentTime', 0 );
			sendToVimeo( 'setVolume', 0 );
		}

		function handleVimeoMessage( event ) {
			if ( event.origin !== vimeoOrigin ) {
				return;
			}

			if ( event.source !== iframeEl.contentWindow ) {
				return;
			}

			if ( ! event.data ) {
				return;
			}

			let data;
			try {
				data = typeof event.data === 'string' ? JSON.parse( event.data ) : event.data;
			} catch ( e ) {
				return;
			}

			if ( ! data || typeof data !== 'object' ) {
				return;
			}

			if ( data.event === 'ready' ) {
				isReady = true;
				bindVimeoEvents();
				setInitialVimeoState();
				syncButtonClasses();
				return;
			}

			if ( data.event === 'play' ) {
				isPlaying = true;
				syncButtonClasses();
				return;
			}

			if ( data.event === 'pause' ) {
				isPlaying = false;
				syncButtonClasses();
			}
		}

		syncButtonClasses();

		window.addEventListener( 'message', handleVimeoMessage, false );
		sendToVimeo( 'addEventListener', 'ready' );

		playBtn.off( 'click.nsVimeoThemeVideo' ).on( 'click.nsVimeoThemeVideo', function( e ) {
			e.preventDefault();
			e.stopPropagation();

			if ( isPlaying ) {
				sendToVimeo( 'pause' );
				return;
			}

			// Unmute and play video
			sendToVimeo( 'setVolume', 1 );
			sendToVimeo( 'play' );
		} );

		if ( ! isReady ) {
			setTimeout( () => {
				sendToVimeo( 'addEventListener', 'ready' );
			}, 250 );
		}
	} );

	if ( jQuery( '.project-teaser-area' ).length > 0 ) {
		const items = jQuery( '.project-teaser-item' ).map( function() {
			return '<div class="project-teaser-item d-flex">' + jQuery( this ).html() + '</div>';
		} ).get();

		const chunkSize = 3;

		let html = '';
		for ( let i = 0; i < items.length; i += chunkSize ) {
			const chunk = items.slice( i, i + chunkSize ).join( '' );
			html += '<div class="project-teaser-row">' + chunk + '</div>';
		}

		jQuery( '.project-teaser-area' ).html( html );
	}
} );
